import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { environment } from 'src/environments/environment';
import { enpointCervinoWeb } from './../../configuration/enpointsCervino';
import { GeneralParameterModel } from './../../models/management/general-parameter.model';

@Injectable({
  providedIn: 'root'
})
export class GeneralParameterService {

  constructor(private _httpClient: HttpClient) { }

  getAllGeneralParameters(): Observable<Array<GeneralParameterModel>> {
    return this._httpClient.get<Array<GeneralParameterModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.generalParameter.GetAllGeneralParameters}`);
  }

  getAllGeneralParameterWithPaginationAsync(companyId: number, page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('companyId', companyId).set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.generalParameter.GetAllGeneralParameterWithPaginationAsync}`,
      filters, { params: params }
    );
  }

  getGeneralParametersByCompany(companyId: number): Observable<Array<GeneralParameterModel>> {
    return this._httpClient.get<Array<GeneralParameterModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.generalParameter.GetGeneralParametersByCompany}/${companyId}`);
  }

  getGeneralParametersByUserAutheticated(): Observable<Array<GeneralParameterModel>> {
    return this._httpClient.get<Array<GeneralParameterModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.generalParameter.GetGeneralParametersByUserAutheticated}`);
  }

  getColumnsGeneralParameter(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.generalParameter.GetColumnsGeneralParameterAsync}`);
  }

  saveGeneralParametersByCompany(companyId: number, generalParametersId: number): Observable<Array<number>> {
    const params = new HttpParams().set('companyId', companyId).set('generalParametersId', generalParametersId);
    return this._httpClient.get<Array<number>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.generalParameter.SaveGeneralParametersByCompany}`,
      { params: params })
  }
}
